module.exports = __webpack_public_path__ + "static/media/FoodIcon.c722deea.png";